var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54 2.874a.65.65 0 0 1 .92 0l4.666 4.666a.65.65 0 0 1 0 .92L8.46 13.126a.65.65 0 0 1-.92-.919l3.557-3.557H3.333a.65.65 0 0 1 0-1.3h7.764L7.54 3.793a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjU0MDQgMi44NzM3M0M3Ljc5NDI0IDIuNjE5ODkgOC4yMDU4IDIuNjE5ODkgOC40NTk2NCAyLjg3MzczTDEzLjEyNjMgNy41NDA0QzEzLjM4MDEgNy43OTQyNCAxMy4zODAxIDguMjA1OCAxMy4xMjYzIDguNDU5NjRMOC40NTk2NCAxMy4xMjYzQzguMjA1OCAxMy4zODAxIDcuNzk0MjQgMTMuMzgwMSA3LjU0MDQgMTMuMTI2M0M3LjI4NjU2IDEyLjg3MjUgNy4yODY1NiAxMi40NjA5IDcuNTQwNCAxMi4yMDcxTDExLjA5NzQgOC42NTAwMkgzLjMzMzM1QzIuOTc0MzYgOC42NTAwMiAyLjY4MzM1IDguMzU5IDIuNjgzMzUgOC4wMDAwMkMyLjY4MzM1IDcuNjQxMDMgMi45NzQzNiA3LjM1MDAyIDMuMzMzMzUgNy4zNTAwMkgxMS4wOTc0TDcuNTQwNCAzLjc5Mjk3QzcuMjg2NTYgMy41MzkxMyA3LjI4NjU2IDMuMTI3NTcgNy41NDA0IDIuODczNzNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";